import { Ga4Transformer } from './Ga4Transformer';

export class UrlTransformers {
    constructor() {
        this.transformers = [];
    }

    addTransformer(transformer) {
        if (!transformer) {
            console.warn('Falsy transformer provided - ignoring');
            return;
        }

        this.transformers.push(transformer);
    }

    clear() {
        this.transformers = [];
    }

    transform(url) {
        const transformerChain = [ ...this.transformers ];
        return this.transformFunctor(url, transformerChain);
    }

    transformFunctor(url, transformerChain) {
        if (transformerChain.length <= 0) {
            return Promise.resolve(url);
        }

        const transform = transformerChain.shift();

        try {
            const result = transform(url);
            return Promise.resolve(result)
                .then(transformedUrl => this.transformFunctor(transformedUrl, transformerChain));
        } catch (e) {
            console.error(`Could not process url - returning ${url}`, e);
            return Promise.resolve(url);
        }
    }
}

function getGa4TransformFunctor(measurementId, googleAdsId) {
    const transformer = new Ga4Transformer(measurementId, googleAdsId);
    return transformer.transform.bind(transformer);
}

UrlTransformers.getTransformer = function(descriptor) {
    if (typeof descriptor === 'function') {
        return descriptor;
    }

    if (!descriptor || !descriptor.id) {
        return null;
    }

    if (descriptor.id === 'ga4' && !!descriptor.measurementId) {
        return getGa4TransformFunctor(
            descriptor.measurementId,
            descriptor.googleAdsId ?? null,
        );
    }

    return null;
};

UrlTransformers.instance = function() {
    if (!UrlTransformers._instance) {
        UrlTransformers._instance = new UrlTransformers();
    }

    return UrlTransformers._instance;
};
